(ns ballot-scout-v2-frontend.dashboard.views.where-are-ballots
  (:require
   [ballot-scout-v2-frontend.components.link :refer [link]]
   [ballot-scout-v2-frontend.dashboard.subs :as s.dashboard]
   [ballot-scout-v2-frontend.subs :as subs]
   [ballot-scout-v2-frontend.util :as util]
   [re-frame.core :as rf]))

(defn status-card [{:keys [label status-counts statuses route-name]}]
  [:div {:class "ballot-status-card"}
   [:div {:class "is-flex is-justify-content-space-between is-align-items-center is-size-7 status-card-header"}
    [:span {:class "paragraph-3 has-text-weight-bold is-uppercase"} label]
    [:span {:class "paragraph-3 has-text-weight-bold is-uppercase"} "Number of ballots"]]

   (into [:<>]
         (for [status (remove nil? statuses)]
           (cond
             (= status ::space-divider)
             [:div {:class "mt-5"}]

             :else
             [:div {:class "is-flex is-justify-content-space-between is-align-items-center"}
              [link {:route-name route-name
                     :params {:partner-slug (:partner/slug @(rf/subscribe [::subs/current-partner]))
                              :jurisdiction-slug (:jurisdiction/slug @(rf/subscribe [::subs/current-jurisdiction]))
                              :election-slug (:election/slug @(rf/subscribe [::subs/current-election]))}
                     :query {:status status}
                     :class "button is-light ballot-status-link has-text-weight-bold"}
               [:span {:key status}
                (util/backend-status->label status)
                (when (util/deprecated-statuses status)
                  [:small {:class "has-text-warning is-size-7"} " (deprecated)"])]]
              [:span {:class "is-align-self-flex-baseline has-text-weight-bold"}
               [:span (get status-counts status 0)]]])))])

(defn ballot-breakdown []
  (let [total-ballots @(rf/subscribe [::s.dashboard/total-ballots])
        delivered-pct @(rf/subscribe [::s.dashboard/delivered-pct])
        rts-count @(rf/subscribe [::s.dashboard/rts-count])
        status-counts @(rf/subscribe [::s.dashboard/ballot-status-counts])
        show-detailed-dispo-counts (:partner/uses-detailed-dispo-statuses
                                    @(rf/subscribe [::subs/current-partner]))
        voter-lookup-route (if @(rf/subscribe [::subs/on-partner-admin-page?])
                             :ballot-scout-v2-frontend.routes/partner-voter-lookup
                             :ballot-scout-v2-frontend.routes/jurisdiction-voter-lookup)]
    [:div {:class "tile is-ancestor"}
     [:div {:class "tile is-parent is-vertical is-4"}
      [:div {:class "tile notification has-text-centered is-fullwidth is-flex-direction-column is-justify-content-space-between"}
       [:h4 {:class "heading-4 is-uppercase pb-5"} "Total ballots tracked"]
       [:h1 {:class "heading-1"} total-ballots]
       [:div
        [link
         {:route-name voter-lookup-route
          :params {:partner-slug (:partner/slug @(rf/subscribe [::subs/current-partner]))
                   :jurisdiction-slug (:jurisdiction/slug @(rf/subscribe [::subs/current-jurisdiction]))
                   :election-slug (:election/slug @(rf/subscribe [::subs/current-election]))}
          :query {:force true}
          :class "button is-light has-text-weight-bold"}
         "View Ballots"]]]

      [:div {:class "tile notification has-text-centered is-fullwidth is-flex-direction-column is-justify-content-space-between"}
       [:h4 {:class "heading-4 is-uppercase pb-5"} "ballots delivered to voter"]
       [:h1 {:class "heading-1"} delivered-pct "%"]
       [:span]]

      [:div {:class "tile notification has-text-centered is-fullwidth is-flex-direction-column is-justify-content-space-between"}
       [:h4 {:class "heading-4 is-uppercase pb-5"} "ballots returned to sender"]
       [:h1 {:class (str "heading-1" (when (pos? rts-count) " has-text-danger-dark"))} rts-count]
       [:div
        [link
         {:route-name voter-lookup-route
          :params {:partner-slug (:partner/slug @(rf/subscribe [::subs/current-partner]))
                   :jurisdiction-slug (:jurisdiction/slug @(rf/subscribe [::subs/current-jurisdiction]))
                   :election-slug (:election/slug @(rf/subscribe [::subs/current-election]))}
          :query {:status "usps/returned"}
          :class "button is-light has-text-weight-bold"}
         "View Ballots"]]]]

     [:div {:class "tile is-parent is-vertical is-8"}
      [:div
       {:class "tile is-child notification ballot-status-tile"}
       [status-card {:label "Office Status - Updated By Disposition Data"
                     :route-name voter-lookup-route
                     :status-counts status-counts
                     :hide-totals? true
                     :statuses [:disposition/created
                                (when show-detailed-dispo-counts :disposition/mailed)]}]]
      [:div {:class "tile is-child notification ballot-status-tile"}
       [status-card {:label "USPS Status - Updated by IMB Scan Data"
                     :route-name voter-lookup-route
                     :status-counts status-counts
                     :statuses [(when (:voter-bound/mailed status-counts)
                                  :voter-bound/mailed)
                                :voter-bound/in-transit
                                :voter-bound/out-for-delivery
                                :voter-bound/delivered
                                ::space-divider
                                (when (:office-bound/mailed status-counts)
                                  :office-bound/mailed)
                                :office-bound/in-transit
                                :office-bound/out-for-delivery
                                :office-bound/delivered

                                ::space-divider
                                :usps/returned]}]]
      (when show-detailed-dispo-counts
        [:div {:class "tile is-child notification ballot-status-tile"}
         [status-card {:label "Office Status - Updated By Disposition Data"
                       :route-name voter-lookup-route
                       :status-counts status-counts
                       :statuses [:disposition/received
                                  :disposition/accepted
                                  :disposition/flagged]}]])]]))

(defn ballots-by-status []
  (let [ballots-by-status @(rf/subscribe [::s.dashboard/ballots-by-status])]
    [:div {:class "ballot-breakdown mb-5"}
     (cond
       (= :loading ballots-by-status)
       [:div#overview.loading {:style {:width "100%"
                                       :height "500px"}}
        [:div {:style {:marginLeft "auto" :marginRight "auto" :width "100px"}}
         [:img {:src "/images/compass-100x100.png"}]]]

       (= :error ballots-by-status)
       [:h4.heading-4.no-data
        "There was an error loading ballot data."]

       (and (seqable? ballots-by-status) (pos? (count ballots-by-status)))
       [:<>
        [:h1 {:class "heading-1"} "Dashboard"]
        [:hr]
        [ballot-breakdown]]

       :else
       [:h4.heading-4.no-data
        "There’s no ballot data yet for this election. Please upload voter "
        "data to see where the ballots are."])]))
